import { useContext, useEffect, useState } from "react";

import { AuthContext } from "../../../contexts/AuthContext";
import { useQuery } from "react-query";
import Avatar from "../../../components/Avatar";
import Button from "../../../components/Button";

import RoleDropdown from "./RoleDropdown";
import { toast } from "react-toastify";
import InviteUsers from "./InviteUsers";
import { DELETE, GET } from "../../../api/requests";
import { TeamContext } from "../../../contexts/TeamContext";
import { useDialog } from "../../../contexts/DialogContext";
import UserList from "../UserList";

export default function Users() {
  const { token } = useContext(AuthContext);
  const { team, roleOnCurrentTeam } = useContext(TeamContext);
  const { showDialog } = useDialog();
  const [invites, setInvites] = useState([]);
  const {
    data: users,
    isError,
    isLoading,
    error,
  } = useQuery(
    ["organizations", team?.id],
    () => {
      return GET(`/organizations/${team.id}/users`);
    },
    {
      enabled: !!token && !!team?.id,
    }
  );

  const { data: inviteData } = useQuery(
    ["invites", team?.id],
    () => {
      return GET(`/organizations/${team.id}/invites`);
    },
    {
      enabled: !!token && !!team?.id,
    }
  );

  useEffect(() => {
    if (inviteData) {
      setInvites(inviteData);
    }
  }, [inviteData]);

  const cancelInvite = async (id) => {
    const deleted = await DELETE(`/organizations/${team.id}/invites/${id}`);
    setInvites(invites.filter((i) => i.id != id));
    toast("Invite canceled");
  };

  const removeUserFromTeam = async (uid) => {
    // TODO: Fix
  };

  return (
    <div className="relative" style={{ height: "100%" }}>
      <div className="flex justify-between items-center">
        <h1 className="text-lg font-bold font-space text-gray-800 mb-6">
          Manage users
        </h1>
        <Button
          style={"filled"}
          label={"Invite users"}
          onClick={() => showDialog(<InviteUsers group_id={team?.id} />)}
        />
      </div>
      <div className="">
        <div className="divide-y">
          <UserList users={users} />
        </div>

        {
          // Only show outstanding invites to admins and owners
          (roleOnCurrentTeam == "owner" || roleOnCurrentTeam == "admin") &&
            invites.length > 0 && (
              <div className="border-t border-gray-100 mt-4">
                <h1 className="text-gray-700 font-space font-semibold text-sm mt-4">
                  Pending invites
                </h1>
                <div className="divide-y">
                  {invites?.map((invite) => {
                    return (
                      <div
                        key={invite.id}
                        className="py-2 flex items-center justify-between w-full"
                      >
                        <div className="flex items-center">
                          <Avatar size={8} name={invite?.email} />

                          <div className="ml-4">
                            <p className="font-medium  text-sm text-gray-800">
                              {invite?.email}
                            </p>
                          </div>
                        </div>
                        <div className="flex space-x-2 items-center">
                          <RoleDropdown
                            resourceType={"organization"}
                            role={invite.role}
                            disabled={true}
                          />
                          {(roleOnCurrentTeam == "owner" ||
                            roleOnCurrentTeam == "admin") && (
                            <Button
                              style={"filled"}
                              onClick={() => cancelInvite(invite.id)}
                              label={"Cancel invite"}
                            />
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )
        }
      </div>
    </div>
  );
}
